import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import ErrorBoundaryRoutes from "../../../components/shared/ErrorBoundaryRoutes";
import VenueListChild from "./VenueListChild";

const VenueList = () => {
  return (
    <MainTemplate>
      <div className="relative flex flex-col p-10 m-3 space-y-10 bg-white rounded-md shadow md:flex-row md:space-y-0 md:m-3">
        <ErrorBoundaryRoutes route="/venues" page="VenueList">
          <VenueListChild />
        </ErrorBoundaryRoutes>
      </div>
    </MainTemplate>
  );
};

export default VenueList;
